export enum RoleKeys {
  ADMIN = 'ADMIN',
  GUEST = 'GUEST',
}

export interface IRoleSourceCodes {
  aud: string
}

export const RoleSourceCodes: Record<string, IRoleSourceCodes> = {
  [RoleKeys.ADMIN]: {
    aud: '1:1',
  },
  [RoleKeys.GUEST]: {
    aud: '1:2',
  },
}
